export default "__VITE_ASSET__B0Iv4G30__"